<template>
  <div>
    <my-order-on-table :cart="cart" :requestingCart="requestingCart" @getCart="getCart" @callWaiter="$emit('callWaiter')" />
    <error-dialog v-if="error.show" :data="error" @DismissErrorDialog="DismissErrorDialog()" />
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
import { track } from "@/services/track-custom";
import { OnTableCart } from "@/services/OnTableCart";
import * as Sentry from '@sentry/browser';

const MyOrderOnTable = () => import(/* webpackChunkName: "MyOrderOnTable" */ "@/components/on_table/MyOrder-OnTable");
const ErrorDialog = () => import(/* webpackChunkName: "ErrorDialog" */ '@/components/cluvi-pay/ErrorDialog.vue');

export default {
  name: "MyOrder",
  data: () => ({
    cart: { total: 0 },
    error: {
			show: false,
			message: "Su cuenta ha sido cerrada",
			icon: "fa-light fa-circle-exclamation"
		}
  }),
  computed: {
    ...mapState('order', ["subservice"]),
    ...mapState('customer', ["supplier"]),
    ...mapState('ontable', ["requesting", "tableId"]),
    ...mapGetters('customer', ["is_ontable_checkout","is_ontable_plazoleta", "has_cluvipay", "is_ontable_basic", "is_ontable_noincremental"]),
    ...mapGetters('order', ["is_room_service"]),
    requestingCart() {
      return this.requesting;
    }
  },
  components: {
    MyOrderOnTable,
    ErrorDialog
  },
  created() {
    this.SetLoading(true);
    this.SetAppClass("background-order");
    this.GetSupplier(this.$route.params.supplier_id);
    this.$vuetify.theme.dark = false;
  },
  methods: {
    ...mapActions('customer', ["GetSupplier"]),
    ...mapActions('order', ["setServiceRoom", 'setMenuDigital']),
    ...mapMutations('template', ["SetLoading","SetAppClass"]),
    ...mapMutations('order', ["SetCountProductsList","SetOtPurchaseId"]),
    ...mapMutations('ontable', ["setCountProductsOrdered", "setRequesting", "setTableId", "SetNavigatorMyOrder"]),
    getCart() {
      this.setRequesting(true);
      OnTableCart.getProductsCart().then((response) => {
        if (this.tableId != response.table_code && response.table_code != null && response.table_code != "")  this.setTableId(response.table_code);
        if ( response?.subservice === 'room'  ) this.setServiceRoom(); else this.setMenuDigital();
        this.cart = response;
        this.SetCountProductsList(this.cart.purchase_product.length)
        this.validateCloseCart();
      }).catch(err => {
        err; this.setRequesting(false);
        Sentry.captureException(err);
      })
      .finally(() => {
        this.setRequesting(false);
      });
    },
    validateCloseCart() {
      if (this.cart.transaction_status === 'approved'){
        this.$router.push({
          name: "Order",
          params: { supplier_id: this.supplier.slug, order_id: this.cart.id }
        });
      }
      if (!this.cart.active_to_diner && this.is_ontable_checkout) {
        this.SetCountProductsList(0);
        this.SetOtPurchaseId(null);
        this.setCountProductsOrdered(0);
        this.error.show = true;
      } else {
        if (this.is_ontable_basic && this.has_cluvipay) this.SetNavigatorMyOrder(2);
      }
    },
    DismissErrorDialog() {
      this.error.show = false;
      const query = {};
      if (this.is_ontable_noincremental) query.mesa = this.tableId;
      if (this.is_ontable_plazoleta || this.is_ontable_noincremental) {
        this.$router.push({
          name: "OnTableMenuDigital",
          params: { supplier_id: this.supplier.slug },
          query
        });
      };
    },
    getParamsFromURL() {
      if (this.$route.params?.purchase_id) {
        this.SetOtPurchaseId(this.$route.params?.purchase_id);
        this.getCart();
      }
    }
  },
  mounted() {
    this.getParamsFromURL();
    setTimeout(() => { 
      this.SetLoading(false); 
    }, process.env.VUE_APP_DELAY);
    track.trackEventCluvi({}, "view cart on table");
    track.trackView(this,`Cart on table`,`/${this.supplier.slug}/menu-digital/my-order`);
    this.$vuetify.theme.dark = false;
  }
};
</script>